import React from 'react';
import './Toast.css';

export default function Toast({ message, type = 'success', onClose }) {
  return (
    <div className={`toast toast--${type}`} onClick={onClose}>
      <span className="toast-icon">{type === 'success' ? '✓' : '!'}</span>
      <span className="toast-msg">{message}</span>
    </div>
  );
}
